/** Rotas e helpers de navegação para conta admin (server + client safe). */

import { isAdminEmail } from '@/lib/admin/allowlist'

export const ADMIN_HOME = '/admin'

/** Rotas do app MEI que admin não deve usar — redireciona para /admin. */
export const USER_APP_ROUTE_PREFIXES = [
  '/dashboard',
  '/onboarding',
  '/registrar',
  '/contadores',
] as const

export function isAdminUserLike(
  user: { email: string; role?: string | null } | null | undefined,
): boolean {
  if (!user || user.role !== 'ADMIN') return false
  return isAdminEmail(user.email)
}

export function isUserAppRoute(pathname: string): boolean {
  return USER_APP_ROUTE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))
}

export function getDefaultAppHome(
  user: { email: string; role?: string | null; plano?: string | null } | null | undefined,
): string {
  if (isAdminUserLike(user)) return ADMIN_HOME
  // Painel é Premium; conta grátis cai nas calculadoras.
  if (user?.plano === 'PREMIUM') return '/dashboard'
  return '/calculadoras'
}

/** Destino após login — admin sempre cai no command center (salvo redirect explícito /admin/*). */
export function resolvePostLoginPath(
  user: { email: string; role?: string | null; plano?: string | null },
  requestedRedirect?: string | null,
): string {
  if (isAdminUserLike(user)) {
    if (requestedRedirect?.startsWith('/admin')) return requestedRedirect
    return ADMIN_HOME
  }
  if (requestedRedirect && !requestedRedirect.startsWith('/admin')) {
    return requestedRedirect
  }
  return getDefaultAppHome(user)
}
